import type { BrandFavicon } from "./types";

// Favicon paths, kept as PURE DATA alongside palette.ts and for the same
// reason: vite.config.ts rewrites index.html's <link rel="icon"> at build time
// and cannot import anything renderable. Each file lives in public/ (unhashed,
// stable) because index.html points at it before any JavaScript runs.
export const BRAND_FAVICONS: Record<string, BrandFavicon> = {
  smartmarket: { href: "/favicon.svg", type: "image/svg+xml" },
  richpoll: { href: "/brand/richpoll/favicon.png", type: "image/png" },
};
